var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"production"},[_c('div',{staticClass:"allShrink"},[_c('div',{staticClass:"header-banner"}),_c('p-quick-link'),_c('MapViewer'),_c('supply-demand'),_c('achieve-display'),_c('landtrust-statistics')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }